export default __webpack_public_path__ + "static/media/DNo.25-5.a227c7de.jpg";